import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    jwt: '',
    refreshToken: '', // thêm refreshToken
    role: '',
    locale: 'vi',
    fullName: ''
  },
  getters: {
    isLogin: state => state.isLogin,
    jwt: state => state.jwt,
    refreshToken: state => state.refreshToken, // thêm getter
    role: state => state.role,
    locale: state => state.locale,
    fullName: state => state.fullName
  },
  mutations: {
    doLogin(state, payload) {
      state.isLogin = true
      state.role = payload.role
      state.fullName = payload.fullName
    },
    saveJwt(state, token) {
      state.jwt = token
    },
    saveRefreshToken(state, token) { // thêm mutation để lưu refresh token
      state.refreshToken = token
    },
    doLogout(state) {
      state.isLogin = false
      state.jwt = ''
      state.refreshToken = '' // xóa refresh token khi logout
      state.role = ''
      state.fullName = ''
    },
    updateFullName(state, fullName) {
      state.fullName = fullName
    },
    updateUserInfo(state, userInfo) {
      state.role = userInfo.role
      state.fullName = userInfo.fullName
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
